import DropTrailerIcon from 'transfix-icons/build/DropTrailerIcon'
import DryVanIcon from 'transfix-icons/build/DryVanIcon'
import FlatBedIcon from 'transfix-icons/build/FlatBedIcon'
import ReeferIcon from 'transfix-icons/build/ReeferIcon'
import SpecializedDeprecatedIcon from 'transfix-icons/build/SpecializedDeprecatedIcon'
import { ISvgIconProps } from 'transfix-ui/components/SvgIcon'
import { IEquipmentTypes } from 'types/graphqlTypes'

export const EQUIPMENT_ICONS: Record<
  IEquipmentTypes,
  React.ForwardRefExoticComponent<ISvgIconProps & React.RefAttributes<SVGSVGElement>>
> = {
  [IEquipmentTypes._20_van]: DryVanIcon,
  [IEquipmentTypes._40_van]: DryVanIcon,
  [IEquipmentTypes._48_flatbed]: FlatBedIcon,
  [IEquipmentTypes._48_reefer]: ReeferIcon,
  [IEquipmentTypes._48_van]: DryVanIcon,
  [IEquipmentTypes._53_flatbed]: FlatBedIcon,
  [IEquipmentTypes._53_reefer]: ReeferIcon,
  [IEquipmentTypes._53_van]: DryVanIcon,
  [IEquipmentTypes.double_drop]: DropTrailerIcon,
  [IEquipmentTypes.dry_van]: DryVanIcon,
  [IEquipmentTypes.ice_cream_trailer]: ReeferIcon,
  [IEquipmentTypes.lift_gate]: FlatBedIcon,
  [IEquipmentTypes.open_deck]: FlatBedIcon,
  [IEquipmentTypes.plate_trailer]: FlatBedIcon,
  [IEquipmentTypes.power_unit]: SpecializedDeprecatedIcon,
  [IEquipmentTypes.reefer]: ReeferIcon,
  [IEquipmentTypes.space_saver_reefer]: ReeferIcon,
  [IEquipmentTypes.specialized]: SpecializedDeprecatedIcon,
  [IEquipmentTypes.stepdeck]: FlatBedIcon,
  [IEquipmentTypes.vented_van]: DryVanIcon,
}

export type TEquipmentIcons = typeof EQUIPMENT_ICONS
